module.exports = __webpack_public_path__ + "static/tow-truck2-d3de5456f748b16c44bb8b1dcd9b5c70.jpg";